/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const ItineraryIcon = ({
  isActive = false,
  className="",
  width = 20,
  height = 20,
}) => {
  let fill;
  if (isActive === false) {
    fill = "#9a9a9a";
  } else {
    fill = "white";
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      test-id="KAsVhhYi"
    >
      <path
        d="M18 2H17V0H15V2H5V0H3V2H2C0.9 2 0 2.9 0 4V20C0 21.1 0.9 22 2 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H2V7H18V20Z"
        fill={fill}
        test-id="yWHC-gss"
      />
    </svg>
  );
};

export default ItineraryIcon;
